import { SET_COGNITO_USER } from '../actions/action-type';

export const setCognitoUser = (content) => ({
  type: SET_COGNITO_USER,
  payload: {
    content
  }
});
